import React, { useState } from "react";
import { formatNumber } from "utils/currencyFormat";
import ChiTietHopDong from "../../../../service/chiTietHopDongApi";
import ChiTietHopDongContainer from "containers/Common/QuanLyChoVay/ChiTietHopDongContainer";
export const BtnChiTietHopDong = ({ item }) => {
  const [showChiTietHopDong, setShowChiTietHopDong] = useState(false);
  const handleCloseChiTietHopDong = () => setShowChiTietHopDong(false);
  const handleShowChiTietHopDong = () => setShowChiTietHopDong(true);

  const objChiTietHopDong = {};
  const [chovayChiTiet, setChoVay] = useState(objChiTietHopDong);

  const timkiemHopDong = { choVayId: 0 };

  const functionChiTietChoVay = () => {
    if (item.ChoVayId != null) {
      timkiemHopDong.choVayId = item.ChoVayId;
      ChiTietHopDong.getChiTietHopDong1(timkiemHopDong.choVayId).then(
        (response) => {
          setChoVay(response.data);
          setShowChiTietHopDong(true);
        }
      );
    } else {
      timkiemHopDong.choVayId = item.NhanVayId;
      ChiTietHopDong.getChiTietHopDong2(item.NhanVayId).then((response) => {
        setChoVay(response.data);
        setShowChiTietHopDong(true);
      });
    }
  };
  return (
    <>
      <a
        onClick={functionChiTietChoVay}
        href={() => false}
        className=" word-break blue btn-link"
      >
        {item.Code}
      </a>
      {showChiTietHopDong && (
        <ChiTietHopDongContainer
          show={handleShowChiTietHopDong}
          onHide={handleCloseChiTietHopDong}
          data={chovayChiTiet}
          setModalTaiSan={handleShowChiTietHopDong}
        ></ChiTietHopDongContainer>
      )}
    </>
  );
};
